export const AUTH_API = {
  RECENT_GAME: '/transaction/bets/recent-games',
}

export const BETS_API = {
  BETS_AGGREGATION: '/transaction/bets/aggregation',
}

export const EVENT_API = {
  RANKING_LIST: '/common-event/total-participants',
  USER_STAKE: '/common-event/auth-user-total-stake',
  GET_USER_REWARD: '/common-event/user-get-reward',
  LUCKY_DRAW_ELIGIBLE: '/lucky-draw/eligibility',
  LUCKY_DRAW: '/lucky-draw/draw',
  LUCKY_DRAW_REWARD: '/lucky-draw/rewards',
}
